import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectMarginCallMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_MARGINCALL);
        this.UserId = null;
        this.AssetId = null;
        this.StopOutType = null;
        this.Balance = null;
        this.UsedMargin = null;
        this.IsMarginCall = null;
    }
}
